module.exports = __webpack_public_path__ + "media/images/IG_Glyph_Fill@3x-a8d91f2e284926ffa9dde43302530c92.png";